import styles from './CircledChevronRight.module.scss';
import classNames from 'classnames/bind';

let cx = classNames.bind(styles);

export function CircledChevronRight({ className }) {
	const classNameArray = className?.split(' ') || [];
	return (
		<svg width="100%" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg" className={cx(['circled-chevron-right-icon', ...classNameArray])} aria-hidden="true">
			<rect x="-.443" y=".443" width="25.114" height="25.114" rx="12.557" transform="matrix(-1 0 0 1 25.114 .5)" fill="#000" />
			<path d="m11.522 7.59 6.205 5.91-6.205 6.204" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
		</svg>
	);
}
